import React from 'react'
import { Link } from 'react-router-dom'
import datas from '../datas/photo'
import {BsHammer} from 'react-icons/bs'

const Photography = () => {
  return (
    <section className='photos bg-bgFooter'>
<h2 className="text-center font-qwitcher text-5xl py-8 ">
        Although I'm a horrible photographer, I can't help snapping</h2>
      <div className="align ">
      <div className="photography grid grid-cols-2 pr-12 md:grid-cols-3 xl:grid-cols-4 gap-x-10 gap-y-14 md:px-32 md:w-11/12 ml-14 ">
            {datas.map((photo, index)=>(
                <img src={photo} alt="" srcset="" key={index} 
                className='w-full h-full rounded-lg' />
            ))}
        </div>

      </div>
      <div className="foot-wrapper py-12 ">
      <p className="text-center text-2xl mb-6">Do you want to see more of it ? I've have built a whole web for you 
      </p>
      <div class="border-solid border-2 text-3xl font-qwitcher w-60 
                text-center mx-auto p-2 border-indigo-600 ...">
              <Link to='/'>VIST SantoshGraphy</Link>

                </div>
                <p className='text-center text-lg p-2'><small className='text-center font-cavaet text-blue-500'>Sorry for the inconvenience, Site is  currently under <span className="text-gray-700 max-w-2 inline-block"><BsHammer/></span> </small></p>
      </div>

    </section>
  )
}

export default Photography